// extracted by mini-css-extract-plugin
export default {"TableFirstElement":"RenderStats_TableFirstElement__LJqaH"};